import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import uuidv4 from 'uuid/v4';
import { customEvent } from '@nerdwallet/nw-client-lib/tracking'; // TODO this should be new click?

var EVENT_NAME = 'GENERIC_CLICK_EVENT';
export var getProgramClickId = function getProgramClickId() {
  return uuidv4();
};
export default (function () {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var uniqueClickId = getProgramClickId();

  var clickProps = _objectSpread({
    uniqueClickId: uniqueClickId
  }, properties);

  customEvent(EVENT_NAME, undefined, {
    clickHeader: clickProps
  });
  return uniqueClickId;
});